<div class="sim-input-container">
  <ng-content select="label" />
  <ng-content select="mat-label" />
  <ng-content select="sim-input" />
  <ng-content select="input" />
  <ng-content select="sim-datepicker" />
  <ng-content select="sim-time-picker" />
  <ng-content select="sim-checkbox" />
  <ng-content select="textarea" />
  <ng-content select="description-field" />
  <ng-content select="ui-switch" />

  <!-- @deprecated -->
  <ng-content select="mat-select" />
  <ng-content select="hint" />
  <ng-content select="mat-chip-list" />
  <ng-content select="mat-checkbox" />
  <!-- /@deprecated -->

  <ng-content select="sim-select" />
  <ng-content select="sim-color-select" />
  <ng-content select="sim-hint" />
  <ng-content select="ui-hint, [uiHint]" />
  <ng-content select="sim-chip-list" />
</div>
